module.exports = __webpack_public_path__ + "img/celestia-small.032e3a1d.png";